import { css } from '@emotion/react';
import { setOpacity } from 'styles/utils';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
import { RegistrationTypes } from '../registrationTypes';
import { Pricify } from '@bondsports/utils';
import RegistrationTitle from './RegistrationTitle/RegistrationTitle';

const registrationTypeCss = (registrationType: RegistrationTypes, colors: IColors) => css`
	min-height: 120px;
	border-radius: 2px;
	background-color: ${registrationType === RegistrationTypes.EARLY_BIRD
		? setOpacity(colors.btnGreenBg || '', 0.1)
		: colors.bg_background_primary};
`;

const untilDateCss = (registrationType: RegistrationTypes, colors: IColors) => css`
	font-size: 1.6rem;
	font-weight: 600;
	line-height: 1.56;
	color: ${registrationType === RegistrationTypes.EARLY_BIRD ? colors.btnGreenBg : colors.tx_text_primary};
	padding-left: 10px;
	padding-top: 7px;
`;

const priceCss = (registrationType: RegistrationTypes, colors: IColors) => css`
	font-size: 2rem;
	font-weight: bold;
	line-height: 1.56;
	color: ${registrationType === RegistrationTypes.EARLY_BIRD ? colors.btnGreenBg : colors.tx_text_primary};
	padding-left: 10px;
`;

interface Props {
	untilDate: string;
	price: number;
	registrationType: RegistrationTypes;
	name: string;
}

const Registration = (props: Props) => {
	const { untilDate, price, registrationType, name } = props;
	const { colors } = useColors();

	return (
		<div css={registrationTypeCss(registrationType, colors)}>
			<RegistrationTitle title={name}/>
			<div css={untilDateCss(registrationType, colors)}>{untilDate}</div>
			<div css={priceCss(registrationType, colors)}>{Pricify(price)}</div>
		</div>
	);
};

export default Registration;
